<template>
    <form @submit.prevent="onSubmit">

        <div v-if="viewData.Errors && viewData.Errors.length > 0">
            <h3>Es sind Fehler aufgetreten</h3>
            <p>Folgende Fehler sind aufgetreten:</p>
            <p v-for="msg in viewData.Errors">{{msg}}</p>
            <p>Bitte korrigieren Sie Ihre Eingaben und schicken Sie das Formular noch einmal ab.</p>
        </div>

        <div v-if="viewData.sent">
            <h3>Vielen Dank für Ihre Nachricht!</h3>
            <p>Ihre Nachricht wurde übermittelt. Wir werden Sie so bald wie möglich zurückrufen.</p>
        </div>

        <div v-if="!viewData.sent" class="input-group">

            <div class="form input-text-single">
                <span class="input">
                    <span class="select-style">
                        <select name="Grund" id="Grund" v-model="model.Grund" required>
                            <option value="" disabled>Grund der Kontaktaufnahme*</option>
                            <option v-for="grund in gruende" :value="grund">{{grund}}</option>
                        </select>
                    </span>
                </span>
            </div>

            <div class="form input-text-single">
                <span class="input">
                    <label for="Nachname">Name*</label>
                    <input id="Nachname" name="Name" type="text" v-model="model.Name" required />
                </span>
            </div>

            <div class="form input-text-single">
                <span class="input">
                    <label for="Email">E-Mail-Adresse*</label>
                    <input id="Email" name="Email" type="text" v-model="model.EMail" required />
                </span>
            </div>

            <div class="form input-text-single">
                <span class="input">
                    <label for="Telefonnummer">Telefonnummer*</label>
                    <input id="Telefonnummer" name="Telefonnummer" type="text" v-model="model.Telefonnummer" required />
                </span>
            </div>

            <div class="form input-text-single">
                <span class="input">
                    <label for="Firma">Institution</label>
                    <input id="Firma" name="Firma" type="text" v-model="model.Firma" />
                </span>
            </div>

            <div class="form input-text-single">
                <span class="input">
                    <label for="Firma">Kundennummer</label>
                    <input id="Kundennummer" name="Kundennummer" type="text" v-model="model.Kundennummer" />
                </span>
            </div>

            <div class="form textarea">
                <span>
                    <label for="Mitteilung">Ergänzende Mitteilung</label>
                    <textarea class="text-box multi-line" id="Mitteilung" name="Mitteilung" style="width: 581px; height: 160px;" v-model="model.Mitteilung" />
                </span>
            </div>

            <div class="form input-submit">
                <input type="submit" name="input-submit" id="input-submit" value="Abschicken">
            </div>

            <div class="textonly legend">
                <p>*Pflichtfelder</p>
            </div>

        </div>

    </form>
     
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    import { extractAttrs } from "../../services/extract-attrs";
    import ApiService from "@/services/apiService";

    const RueckrufForm = defineComponent({
        name: "RueckrufForm",
        data() {
            return {
                viewData: Object,
                model: { SessionId: "", Grund: "", Name: "", EMail: "", Telefonnummer: "", Firma: "", Kundennummer: "", Mitteilung: "" },
                gruende: ["Zugangsdaten vergessen", "Fragen zur Registrierung", "Bitte um Rückruf", "Sonstiges"],
            }
        },
        props: {
            container: HTMLDivElement
        },
        async beforeMount() {
            var attrs = extractAttrs(this.container);
            this.model.SessionId = attrs["session"];
            return false; // Erzeugt den Promise
        },
        methods: {
            async onSubmit() {
                this.viewData = await ApiService.Instance.PostData("/umbraco/login/RueckrufForm/SendMail", this.model);
                return false; // Erzeugt den Promise
            },
        },
    });
    export default RueckrufForm;
</script>
